import { Link } from 'react-router';
import { Empty } from '../components/Panel';

export function NotFoundPage() {
  return (
    <Empty title="This page is not in the ledger.">
      <Link to="/">Return to the dashboard</Link>
    </Empty>
  );
}
